<template>
  <div class="requirements-list-area bg-gray">
    <div class="row align-items-center">
      <div class="col-lg-6 two-order-switch">
        <div class="requirements-list mx-auto">
          <h2 class="requirements-list__title mb-15 wow move-up">
            Als exklusiv-Kunde auf dem MHP-Portal
          </h2>
          <p class="heading mb-30 wow move-up">
            Über unser MHP-Portal haben Sie die Möglichkeit Ihre gesamte Bibliothek oder auch nur Teile zur direkten
            Vermittlung an ein Netzwerk mit über 100.000 Interessenten anzubieten und marktgerechte Offerten zu erhalten
            - ohne eine Vermittlungsgebühr zahlen zu müssen. Sie können damit Ihre derzeitige Bibliotheksstruktur
            optimieren oder mit der Veräußerung andere Investitionen tätigen. Mit unserer Expertise im Bereich der
            Faksimiles und weiteren Produkten begleiten wir Sie von Beginn an und unterstützen Ihr Vorhaben mit
            umfassenden Dienstleistungen wie z.B. der Bestandsaufnahme und Zustandsbeurkundung Ihrer Bibliothekssammlung
            als auch die Erfassung Ihrer Ausgaben für diese. Unser Ziel ist es, die Einrichtung Ihres Profils auf dem
            MHP-Portal möglichst einwandfrei zu gestalten.
          </p>
        </div>
      </div>
      <div class="col-lg-6 two-order-switch">
        <div class="requirements-list-image wow move-up left">
          <img src="../assets/img/features/Online_collaboration.svg" class="img-fluid" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'requireList'
}
</script>

<style lang="scss">
@use '../assets/scss/variabls.scss' as vars;

@media #{vars.$large-mobile} {
  .two-order-switch {
    &:first-of-type {
      order: 2;
    }
    &:last-of-type {
      order: 1;
    }
  }
}

@media #{vars.$tablet-up} {
  .two-order-switch {
    &:first-of-type {
      order: 1;
    }
    &:last-of-type {
      order: 2;
    }
  }
}
</style>
